export default __webpack_public_path__ + "static/media/hht2_ep12_speaking_04.4948a801.png";